module.exports = __webpack_public_path__ + "bo.svg?2b6773a9f72cc831c5fd8ac5a2115576";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/bo.svg
// module id = 1012
// module chunks = 0